import React, { useState } from "react";
import CustomNavbar from "../../components/common/CustomNavbar";
import PageLayout from "../../components/layouts/PageLayout";
import { whtsappIcon, bulkUser, singleUser } from "../../asset";
import SendMsgComponent from "./SendMsgComponent"; // adjust path as needed
import { useNavigate, useParams } from "react-router-dom";

type MessageMode = "single" | "bulk";

export default function SendMessage() {
  const navigate = useNavigate();
  const { mode } = useParams<{ mode: MessageMode }>();

  const currentMode: MessageMode = mode === "bulk" ? "bulk" : "single";

  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <div className="flex gap-3 items-center w-max">
            <img src={whtsappIcon} className="w-10 h-10" />
            <span className="font-bold text-lg uppercase">
              SEND {mode === "single" ? "SINGLE" : "BULK"}  WHATSAPP MESSAGE
            </span>
          </div>
        </CustomNavbar>
      }
    >
      {/* Top action bar */}
      <div className="rounded-4xl w-full p-4 flex items-center justify-end">
        <div className="flex gap-3">

          {/* SINGLE */}
          <button
            onClick={() => navigate("/send-message/single")}
            className={`flex items-center text-sm gap-2 px-4 py-2 rounded-full border font-semibold transition
              ${mode === "single"
                ? "bg-brand-blue-gradient text-white border-transparent"
                : "border-gray-300 hover:bg-brand-blue-gradient hover:text-white"
              }`}
          >
            <img src={singleUser} className="w-4 h-4" />
            Single Message
          </button>

          {/* BULK */}
          <button
            onClick={() => navigate("/send-message/bulk")}
            className={`flex items-center text-sm gap-2 px-4 py-2 rounded-full border font-semibold transition
              ${mode === "bulk"
                ? "bg-brand-blue-gradient text-white border-transparent"
                : "border-gray-300 hover:bg-brand-blue-gradient hover:text-white"
              }`}
          >
            <img src={bulkUser} className="w-4 h-4" />
            Bulk Message
          </button>

        </div>
      </div>

      {/* Render form inline — pass mode as prop */}
      <SendMsgComponent mode={currentMode} />
      
    </PageLayout>
  );
}
